import mmenu from 'jquery.mmenu';
import $ from 'jquery';

export class mmenuStarter {
	
		constructor() {
			var $menu = $("#menu").mmenu({
			   "extensions": [
					"position-right"
				]
			});
			var $icon = $("#mmenu-hamburger");
			var API = $menu.data( "mmenu" );

			$icon.on( "click", function() {
			
				if ($('html').hasClass('mm-wrapper_opened')) {
					API.close();
				} else {
					API.open();
				}
			});


			API.bind( "open:finish", function() {
			   setTimeout(function() {
			      $icon.addClass( "is-active" );
			   }, 0);
			});
			API.bind( "close:finish", function() {
			   setTimeout(function() {
			      $icon.removeClass( "is-active" );
			   }, 0);
			});

			
			$(window).off($['mmenu'].keydown); // Disable mmenu's keydown
			// Write our own keydown method which prevents tabbing outside the menu when it is open
			$(window).on('keydown', function(e) {
				if ($('html').hasClass('mm-wrapper_opened')) {
					if (e.key == 'Escape') { // esc
						API.close();
					} else if (e.key == 'Tab') { // tab
						let $target = $(e.target);
						// If the event target doesn't have the menu as its parent or it is the last link in the last li
						if (
							!$target.closest('#menu').length || 
							($target.closest('li').is(':last-child') && $target.is(':last-child'))) {

								$('#menu .mm-panel_opened a[href]').first().focus(); // focus the first menu item link
								e.preventDefault();
								return false;
						}
					}
				}
			});
		}
	
}

// export class Foo {
//   constructor() {
//     console.log("FOO");
//   }
// }

